const $inject = ['$scope', 'lbModalService'];

const lbCarHandlingModalCtrl = function ($scope, lbModalService) {
  let vm = this;

  const params = lbModalService.params();
  const deliveryActive = !!params.delivery || params.request === 'delivery';
  const collectionActive = !!params.collection || params.request === 'collection';
  const usStates = require('./usStates.js');

  vm.usStates = _.map(_.keysIn(usStates), (stateCode) => {
    return {
      code: stateCode,
      name: usStates[stateCode],
    };
  });

  vm.collection = {
    location: params.collection,
    isValid: !!params.collection,
    isEnabled: !!params.collectionEnabled,
    isActive: collectionActive,
    isEditing: collectionActive,
    displaySummary: false,
  };

  vm.delivery = {
    location: params.delivery,
    isValid: !!params.location,
    isEnabled: !!params.deliveryEnabled,
    isActive: deliveryActive,
    isEditing: deliveryActive,
    displaySummary: false,
  };

  vm.edit = edit;
  vm.request = request;
  vm.cancel = lbModalService.reject;
  vm.submit = submit;

  if (vm.collection.location && vm.delivery.location && _.isEqual(vm.collection.location, vm.delivery.location)) {
    if (params.request === 'delivery') {
      vm.collection.location = vm.delivery.location;
      vm.collection.isEditing = false;
    }

    if (params.request === 'collection') {
      vm.delivery.location = vm.collection.location;
      vm.delivery.isEditing = false;
    }
  }

  function edit(location) {
    if (location === 'collection') {
      vm.collection.location = undefined;
      vm.collection.isEditing = true;
    }

    if (location === 'delivery') {
      vm.delivery.location = undefined;
      vm.delivery.isEditing = true;
    }
  }

  function request(location, value) {
    if (location === 'collection') {
      if (value) {
        vm.collection.location = vm.delivery.location;
        vm.collection.isEditing = !vm.delivery.isActive;
      } else {
        vm.collection.location = undefined;
        vm.collection.isEditing = false;
        vm.delivery.isEditing = !vm.collection.isActive;
      }
    }

    if (location === 'delivery') {
      if (value) {
        vm.delivery.location = vm.collection.location;
        vm.delivery.isEditing = !vm.collection.isActive;
      } else {
        vm.delivery.location = undefined;
        vm.delivery.isEditing = false;
        vm.collection.isEditing = !vm.delivery.isActive;
      }
    }
  }

  function submit() {
    const delivery = _.clone(vm.delivery.location);
    const collection = _.clone(vm.collection.location);

    lbModalService.resolve({ delivery, collection });
  }
};

lbCarHandlingModalCtrl.$inject = $inject;

export default lbCarHandlingModalCtrl;



// WEBPACK FOOTER //
// ./src/components/lbCarHandlingModal/lbCarHandlingModalCtrl.js